import { adminApiFetch } from '../../../utils/adminApi.js';

const BASE = '/api/admin/hp';

function json(method, body) {
  return {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  };
}

export const hpApi = {
  meta: () => adminApiFetch(`${BASE}/meta`),

  listPosts: () => adminApiFetch(`${BASE}/posts`),
  createPost: (post) => adminApiFetch(`${BASE}/posts`, json('POST', post)),
  updatePost: (id, post) => adminApiFetch(`${BASE}/posts/${encodeURIComponent(id)}`, json('PUT', post)),
  deletePost: (id, reason) => adminApiFetch(`${BASE}/posts/${encodeURIComponent(id)}`, json('DELETE', { reason })),
  importPrTimes: (url, { mode = 'draft', allowDuplicate = false } = {}) => adminApiFetch(`${BASE}/posts/import/prtimes`, json('POST', { url, mode, allowDuplicate })),
  pendingPrTimes: () => adminApiFetch(`${BASE}/prtimes/pending`),
  setPrTimesIgnored: (url, ignored, title = '') => adminApiFetch(`${BASE}/prtimes/ignored`, json('PUT', { url, ignored, title })),

  getCompany: () => adminApiFetch(`${BASE}/company`),
  saveCompany: (company) => adminApiFetch(`${BASE}/company`, json('PUT', company)),

  listPeople: (kind) => adminApiFetch(`${BASE}/people/${kind}`),
  createPerson: (kind, item) => adminApiFetch(`${BASE}/people/${kind}`, json('POST', item)),
  updatePerson: (kind, id, item) => adminApiFetch(`${BASE}/people/${kind}/${encodeURIComponent(id)}`, json('PUT', item)),
  deletePerson: (kind, id, reason) => adminApiFetch(`${BASE}/people/${kind}/${encodeURIComponent(id)}`, json('DELETE', { reason })),
  reorderPeople: (kind, ids) => adminApiFetch(`${BASE}/people/${kind}/reorder`, json('PUT', { ids })),

  getCrossborder: () => adminApiFetch(`${BASE}/legal/crossborder`),
  saveCrossborder: (doc) => adminApiFetch(`${BASE}/legal/crossborder`, json('PUT', doc)),
  getPortalLegal: (type) => adminApiFetch(`${BASE}/legal/portal/${type}`),

  uploadImage: (folder, file) => {
    const form = new FormData();
    form.append('image', file);
    return adminApiFetch(`${BASE}/images?folder=${encodeURIComponent(folder)}`, { method: 'POST', body: form });
  },
  uploadVideo: (file) => {
    const form = new FormData();
    form.append('video', file);
    return adminApiFetch(`${BASE}/videos`, { method: 'POST', body: form });
  },
};

/** HP 側と同じ規則（半角英小文字・数字・ハイフン） */
export const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function suggestSlug(input) {
  return String(input || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
}

/** 公開状態（HP 側の判定と同じ: 公開フラグ + 公開日時/予約日時の到来） */
export function postStatus(post, now = Date.now()) {
  if (!post.published) return { key: 'draft', label: '下書き' };
  const from = Math.max(Date.parse(post.publishedAt || 0) || 0, Date.parse(post.scheduledPublishAt || 0) || 0);
  if (from > now) return { key: 'scheduled', label: '予約公開' };
  return { key: 'live', label: '公開中' };
}
